import type {
  CharacterCompassPageQuery,
  CharacterCompassQuery,
  CharacterCompass,
  CharacterCompassPage,
} from '@edwin-group/cj-graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import {
  MUTATION_UPDATE_STAFF_ONBOARD_CHARACTER_COMPASS,
  QUERY_CHARACTER_COMPASS,
  QUERY_CHARACTER_COMPASS_PAGE,
  //   MUTATION_UPDATE_USER_TRACKING,
} from '@edwin-group/cj-graphql';
import { getAuthentication } from '@/hooks/useAuthentication';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<CharacterCompassPageQuery>({
      query: QUERY_CHARACTER_COMPASS_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.characterCompassPage?.data?.attributes as CharacterCompassPage,
    error,
  };
};

export const getCharacterCompass = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<CharacterCompassQuery>({
      query: QUERY_CHARACTER_COMPASS,
    }),
  );

  return {
    traits: data?.characterCompass?.data as CharacterCompass[],
    error,
  };
};

export async function onChangeTrackingTraits(disable: boolean) {
  return Promise.resolve({ disable });
  // const apolloClient = initializeApollo();
  // const { data } = await requestHandler(
  //   apolloClient.mutate({
  //     mutation: MUTATION_UPDATE_USER_TRACKING,
  //     variables: {
  //       id: getAuthentication()?.user?.id,
  //       input: {
  //         isCharacterCompassTrackingDisabled: disable,
  //       },
  //     },
  //   }),
  // );
  // return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onChangeOnboardStatus() {
  const apolloClient = initializeApollo();
  const { data } = await requestHandler(
    apolloClient.mutate<{ updateUsersPermissionsUser: { data: { attributes: unknown } } }>({
      mutation: MUTATION_UPDATE_STAFF_ONBOARD_CHARACTER_COMPASS,
      variables: {
        id: getAuthentication()?.user?.id,
        input: {
          onboardCharacterCompassCompleted: true,
        },
      },
    }),
  );
  return data?.updateUsersPermissionsUser?.data?.attributes;
}
